import { render, staticRenderFns } from "./PrkGenerateSyllabus.vue?vue&type=template&id=4743d87c&"
import script from "./PrkGenerateSyllabus.vue?vue&type=script&lang=js&"
export * from "./PrkGenerateSyllabus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports